(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() { super(); }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.setHeaderHeight();
      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      if (this.headerIsAlwaysSticky) { this.header.classList.add('shopify-section-header-sticky'); }
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.createObserver();
    }
    setHeaderHeight() { document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`); }
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
      observer.observe(this.header);
    }
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = setTimeout(() => { this.preventReveal = false; }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
      this.currentScrollTop = scrollTop;
    }
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }
  customElements.define('sticky-header', StickyHeader);

  class KsAnnouncementBar extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('.ks-announce-bar__slide'));
      this.index = 0;
      const prev = this.querySelector('.ks-announce-bar__arrow--prev');
      const next = this.querySelector('.ks-announce-bar__arrow--next');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));
    }
    go(i) {
      if (!this.slides.length) return;
      this.slides[this.index].hidden = true;
      this.index = (i + this.slides.length) % this.slides.length;
      this.slides[this.index].hidden = false;
    }
  }
  customElements.define('ks-announcement-bar', KsAnnouncementBar);

  /* ---- open nav dropdowns / mega menu on hover (desktop only) ---- */
  (function () {
    var desktopQuery = window.matchMedia('(min-width: 990px)');

    function initHoverMenus() {
      var items = document.querySelectorAll('.ks-nav-row > nav > ul > li');
      items.forEach(function (li) {
        var details = li.querySelector(':scope > header-menu > details');
        if (!details || li.dataset.ksHoverBound) return;
        li.dataset.ksHoverBound = 'true';

        var closeTimer = null;

        li.addEventListener('mouseenter', function () {
          if (!desktopQuery.matches) return;
          clearTimeout(closeTimer);
          items.forEach(function (other) {
            if (other === li) return;
            var otherDetails = other.querySelector(':scope > header-menu > details');
            if (otherDetails) otherDetails.removeAttribute('open');
          });
          details.setAttribute('open', '');
        });

        li.addEventListener('mouseleave', function () {
          if (!desktopQuery.matches) return;
          closeTimer = setTimeout(function () {
            details.removeAttribute('open');
          }, 150);
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initHoverMenus);
    } else {
      initHoverMenus();
    }
  })();

  /* ---- inline predictive search ---- */
  class KsPredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-ks-search-input]');
      this.resultsEl = this.querySelector('[data-ks-search-results]');
      this.searchUrl = this.getAttribute('data-search-url');
      this.predictiveUrl = this.getAttribute('data-predictive-search-url');
      this.debounceTimer = null;
      this.abortController = null;

      this.input.addEventListener('input', this.onInput.bind(this));
      this.input.addEventListener('focus', function () {
        if (this.input.value.trim().length > 1 && this.resultsEl.innerHTML) {
          this.open();
        }
      }.bind(this));
      document.addEventListener('click', function (event) {
        if (!this.contains(event.target)) this.close();
      }.bind(this));
      this.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') this.close();
      }.bind(this));
    }

    onInput(event) {
      var query = event.target.value.trim();
      clearTimeout(this.debounceTimer);
      if (query.length < 1) {
        this.close();
        return;
      }
      this.debounceTimer = setTimeout(function () {
        this.fetchResults(query);
      }.bind(this), 180);
    }

    fetchResults(query) {
      if (this.abortController) this.abortController.abort();
      this.abortController = new AbortController();

      var base = this.predictiveUrl || '/search/suggest';
      if (base.indexOf('.json') === -1) base += '.json';

      var url = base + '?q=' + encodeURIComponent(query) +
        '&resources[type]=product,query&resources[limit]=6' +
        '&resources[options][unavailable_products]=last';

      fetch(url, {
        signal: this.abortController.signal,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (response) {
          if (!response.ok) throw new Error('predictive search request failed');
          return response.json();
        })
        .then(function (data) {
          this.render(data, query);
        }.bind(this))
        .catch(function (error) {
          if (error.name !== 'AbortError') this.close();
        }.bind(this));
    }

    render(data, query) {
      var results = (data && data.resources && data.resources.results) || {};
      var products = results.products || [];
      var queries = results.queries || [];

      if (!products.length && !queries.length) {
        this.resultsEl.innerHTML = '<p class="ks-search-results__empty">No results for &ldquo;' + this.escapeHtml(query) + '&rdquo;</p>';
        this.open();
        return;
      }

      var html = '';

      queries.forEach(function (q) {
        html += '<a class="ks-search-results__query" href="' + this.searchUrl + '?q=' + encodeURIComponent(q.text) + '">' + q.styled_text + '</a>';
      }.bind(this));

      products.forEach(function (product) {
        var image = product.featured_image ? product.featured_image.url : (product.image || '');
        html += '<a class="ks-search-results__item" role="option" href="' + product.url + '">' +
          (image ? '<img src="' + image + '" alt="" loading="lazy" width="44" height="44">' : '') +
          '<span><span class="ks-search-results__item-title">' + this.escapeHtml(product.title) + '</span>' +
          '</br><span class="ks-search-results__item-price">' + (product.price || '') + '</span></span></a>';
      }.bind(this));

      html += '<a class="ks-search-results__viewall" href="' + this.searchUrl + '?q=' + encodeURIComponent(query) + '">View all results for &ldquo;' + this.escapeHtml(query) + '&rdquo;</a>';

      this.resultsEl.innerHTML = html;
      this.open();
    }

    escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str || '';
      return div.innerHTML;
    }

    open() {
      this.resultsEl.classList.add('is-open');
      this.input.setAttribute('aria-expanded', 'true');
    }

    close() {
      this.resultsEl.classList.remove('is-open');
      this.input.setAttribute('aria-expanded', 'false');
    }
  }
  customElements.define('ks-predictive-search', KsPredictiveSearch);

  } catch(e) { console.error(e); }
})();
})();
